import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { SECTORS_PATHS } from '../sectors';
import { BreadcrumbsService } from '../../../shared/breadcrumbs/breadcrumbs.service';
import { Breadcrumb } from '../../../shared/breadcrumbs/breadcrumbs';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-sectors-edit',
  templateUrl: './sectors-edit.component.html',
  styleUrls: ['./sectors-edit.component.scss'],
  standalone: false,
})
export class SectorsEditComponent implements OnInit {
  plotsEditBreadcrumbs: Breadcrumb[] = [
    { text: 'Участки', url: SECTORS_PATHS.sectors },
    { text: 'Редактирование участка', url: null },
  ];

  constructor(private breadcrumbsService: BreadcrumbsService) {}

  ngOnInit() {
    this.breadcrumbsService.updateBreadcrumbs(this.plotsEditBreadcrumbs);
  }
}
